"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processMaterials = void 0;
const materialProperties = {
    name: 'name',
    doubleSided: 'doubleSided',
    emissiveFactor: 'emissiveFactor',
};
const materialTextures = {
    normalTexture: 'normalTexture',
    emissiveTexture: 'emissiveTexture',
    occlusionTexture: 'occlusionTexture',
};
// TODO when I get time.. do more material details!
function processMaterials(gltfRaw, gbObject) {
    var _a, _b;
    gbObject.textures = (_a = gltfRaw.textures) === null || _a === void 0 ? void 0 : _a.map((rawTexture, index) => {
        const uri = gltfRaw.images[rawTexture.source].uri;
        return {
            uri,
        };
    });
    gbObject.materials = (_b = gltfRaw.materials) === null || _b === void 0 ? void 0 : _b.map((rawMaterial, index) => {
        var _a, _b;
        let texture = 0;
        texture = (_b = (_a = rawMaterial.pbrMetallicRoughness) === null || _a === void 0 ? void 0 : _a.baseColorTexture) === null || _b === void 0 ? void 0 : _b.index;
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        const material = {};
        if (texture !== undefined) {
            material.diffuseTexture = texture;
        }
        Object.keys(materialProperties).forEach((i) => {
            if (rawMaterial[i] !== undefined) {
                material[i] = rawMaterial[i];
            }
        });
        Object.keys(materialTextures).forEach((i) => {
            if (rawMaterial[i] !== undefined) {
                material[i] = rawMaterial[i].index;
            }
        });
        return material;
    });
}
exports.processMaterials = processMaterials;
